import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Box,
} from "@mui/material";
import { fetchJewellersSidebarRequest } from "../../../redux/JewellerList/JewellerSlice";

const DropdownList = ({
  selectedId,
  onChange,
  label = "Jeweller Name",
  disabled = false,
  placeholder = "Choose a Jeweller",
}) => {
  const dispatch = useDispatch();

  const { jewellersSidebar = [], loading } = useSelector(
    (state) => state.jeweller
  );

  useEffect(() => {
    dispatch(fetchJewellersSidebarRequest());
  }, [dispatch]);

  return (
    <FormControl
      fullWidth
      disabled={disabled || loading}
      sx={{
        "& .MuiOutlinedInput-root": {
          border: "none",
          "& fieldset": {
            border: "none",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          backgroundColor: "transparent",
        },
        "& .MuiInputBase-input": {
          color: "#7028DA", // Text color inside Select
          fontWeight: "bold",
        },
        "& .MuiInputLabel-root": {
          color: "#000000", // Label text color
        },
        "& .MuiSvgIcon-root": {
          color: "#7028DA", // Dropdown arrow icon color
        },
      }}
    >
      <InputLabel id="jeweller-select-label">{label}</InputLabel>
      <Select
        sx={{
          width: "100%", // ensures full width
          minWidth: { xs: "210px", sm: "160px" }, // optional
        }}
        labelId="jeweller-select-label"
        value={selectedId || ""}
        label={label}
        onChange={onChange}
      >
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>

        {jewellersSidebar
          .slice()
          .sort((a, b) => a.jewellerName.localeCompare(b.jewellerName))
          .map((jeweller) => (
            <MenuItem key={jeweller.id} value={jeweller.id}>
              {jeweller.jewellerName}
            </MenuItem>
          ))}
      </Select>

      {loading && (
        <Box mt={1} display="flex" justifyContent="center">
          <CircularProgress size={20} />
        </Box>
      )}
    </FormControl>
  );
};

export default DropdownList;
